module.exports = __webpack_public_path__ + "img/logout.9b55b335.svg";